/**
 * Yotpo Widget Reinitializer
 *
 * This script tracks AJAX requests and DOM changes to automatically reinitialize
 * Yotpo widgets when needed, especially after collection filtering.
 */

(function () {
  let isAjaxPending = false;
  let isProcessing = false;
  let isPageLoaded = false;
  let yotpoObserver = null;

  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);
    const url = args[0];

    if (
      typeof url === "string" &&
      url.includes("/collections/") &&
      isPageLoaded
    ) {
      isAjaxPending = true;

      response
        .clone()
        .text()
        .then(() => {
          if (isAjaxPending && !isProcessing) {
            isProcessing = true;
            reinitializeYotpoWidgets();
            isAjaxPending = false;
            isProcessing = false;
          }
        })
        .catch((error) => {
          console.error("Error processing AJAX response:", error);
          isAjaxPending = false;
          isProcessing = false;
        });
    }

    return response;
  };

  const debounceReinitialize = debounce(() => {
    if (!isProcessing) {
      isProcessing = true;
      reinitializeYotpoWidgets();
      isProcessing = false;
    }
  }, 500);

  function reinitializeYotpoWidgets() {
    const yotpoWidgets = document.querySelectorAll(".yotpo-widget-instance");

    if (yotpoWidgets.length === 0) {
      // No Yotpo widgets found on page
      return false;
    }

    const uninitializedWidgets = Array.from(yotpoWidgets).filter(
      (widget) =>
        widget.children.length === 0 &&
        widget.hasAttribute("data-yotpo-product-id")
    );

    if (
      uninitializedWidgets.length > 0 &&
      typeof yotpoWidgetsContainer !== "undefined"
    ) {
      try {
        yotpoWidgetsContainer.initWidgets &&
          yotpoWidgetsContainer.initWidgets();          
        return true;
      } catch (error) {
        console.error("Error initializing Yotpo widgets:", error);
        return false;
      }
    } else if (uninitializedWidgets.length > 0) {
      console.log(
        "Yotpo object not available yet, widgets cannot be initialized"
      );
      return false;
    } else {
      return false;
    }
  }

  function setupYotpoObserver() {
    const containerSelectors = [
      ".collection-grid",
      "#ProductGridContainer",
      ".product-grid",
      ".collection",
    ];

    let productContainer = null;

    for (const selector of containerSelectors) {
      const container = document.querySelector(selector);
      if (container) {
        productContainer = container;
        break;
      }
    }

    if (!productContainer) {
      return null;
    }

    const observer = new MutationObserver((mutations) => {
      const hasSignificantChanges = mutations.some(
        (mutation) =>
          mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0
      );

      if (hasSignificantChanges) {
        debounceReinitialize();
      }
    });

    observer.observe(productContainer, {
      childList: true,
      subtree: true,
    });

    return observer;
  }

  document.addEventListener("DOMContentLoaded", () => {
    isPageLoaded = true;

    debounceReinitialize();
    yotpoObserver = setupYotpoObserver();
  });

  window.addEventListener("beforeunload", () => {
    if (yotpoObserver) {
      yotpoObserver.disconnect();
    }
  });

  document.addEventListener("shopify:section:load", () => {
    debounceReinitialize();
  });

  window.addEventListener("load", () => {
    debounceReinitialize();
  });

  document.addEventListener("ajaxComplete", () => {
    debounceReinitialize();
  });

  // For themes that might use pushState for navigation
  window.addEventListener("popstate", () => {
    debounceReinitialize();
  });
})();
